import React from "react";
import { Outlet } from "react-router-dom";
import AuthGuard from "./AuthGuard";
import UserAlreadyExistsModal from "../components/UserAlreadyExistsModal";

export const Auth = () => {
  return (
    <AuthGuard isPublic={true}>
      <UserAlreadyExistsModal />
      <Outlet />
    </AuthGuard>
  );
};
